import { TestCaseDto } from "src/app/models/dto/testCaseDto";
import { Scope } from "src/app/services/migration/dual-api.service";

export namespace TestCasesActions {
    export class LoadPageOfAllTestCases {
    static readonly type = '[TestCases] LoadPageOfAllTestCases';
    constructor(public page: number, public pageSize: number) {}
  }

  export class PrefetchNextPageOfAllTestCases {
    static readonly type = '[TestCases] PrefetchNextPageOfAllTestCases';
    constructor(public page: number, public pageSize: number) {}
  }

  export class LoadPageOfFunctionalGroupTestCasesPaginated {
    static readonly type = '[TestCases] LoadPageOfFunctionalGroupTestCasesPaginated';
    constructor(public page: number, public pageSize: number, public groupId: string) {}
  }

  export class PrefetchNextPageOfFunctionalGroupTestCases {
    static readonly type = '[TestCases] PrefetchNextPageOfFunctionalGroupTestCases';
    constructor(public page: number, public pageSize: number, public groupId: string) {}
  }

  export class LoadPageOfMyTestCases {
    static readonly type = '[TestCases] LoadPageOfMyTestCases';
    constructor(public page: number, public pageSize: number, public userId: string) {}
  }

  export class PrefetchNextPageOfMyTestCases {
    static readonly type = '[TestCases] PrefetchNextPageOfMyTestCases';
    constructor(public page: number, public pageSize: number, public userId: string) {}
  }

    export class LoadPageOfSearchedTestCases {
    static readonly type = '[TestCases] LoadPageOfSearchedTestCases';
    constructor(public testCase: TestCaseDto, public page: number, public pageSize: number, public resetSearch: boolean, public scope?: Scope) {}
  }

  export class DeleteTestCase {
    static readonly type = '[TestCases] DeleteTestCase';
    constructor(public testCaseUid: string, public regBy: string) {}
  }

  export class UpdateItem {
    static readonly type = '[TestCases] UpdateItem';
    constructor(public item: any) {}
  }

  export class ClearCache {
    static readonly type = '[TestCases] ClearCache';
    constructor() {}
  }
}
